import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { MailDetail } from 'src/app/core/_models/mailDetail';
import { MailService } from 'src/app/core/_services/mail.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';

@Component({
  selector: 'app-dialog-email-detail',
  templateUrl: './dialog-email-detail.component.html',
  styleUrls: ['./dialog-email-detail.component.scss']
})
export class DialogEmailDetailComponent implements OnInit {
  @ViewChild('addressList') private addressList!: TemplateRef<unknown>;

  readonly previewCount = 20;
  detail?: MailDetail;

  constructor(
    public dialogRef: MatDialogRef<DialogEmailDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string },
    private dialog: MatDialog,
    private mailService: MailService,
    private snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.mailService.getSentMail(this.data.id).subscribe({
      next: (detail) => (this.detail = detail),
      error: () => {
        this.snackbarService.open(SnackbarTypes.error);
        this.dialogRef.close();
      }
    });
  }

  listDialog?: MatDialogRef<unknown>;
  listTitle = '';
  listAddresses: string[] = [];

  openAddressList(title: string, addresses: string[]): void {
    this.listTitle = title;
    this.listAddresses = addresses;
    this.listDialog = this.dialog.open(this.addressList, { width: '480px', maxWidth: '94vw', autoFocus: false });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
